import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultFormMarkingAsPaid = {
  paymentDate: null
};
export default {
  name: "ConsultantCommissionPayment",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    order: Object
  },
  data: function data() {
    return {
      markingAsPaid: {
        isConfiguring: false,
        dateMenu: null,
        form: _objectSpread({}, defaultFormMarkingAsPaid),
        isPending: false,
        cancellationToken: null
      },
      markingAsNotPaid: {
        isPending: false,
        cancellationToken: null
      },
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    paymentStatus: function paymentStatus() {
      return this.order.isConsultantCommissionPaid ? {
        badgeClass: "success",
        label: "PAID"
      } : {
        badgeClass: "warning",
        label: "NOT PAID"
      };
    }
  },
  methods: {
    startConfigureMarkAsPaid: function startConfigureMarkAsPaid() {
      this.markingAsPaid.form = {
        paymentDate: this.order.dateConsultantCommissionPaid
      };
      this.markingAsPaid.isConfiguring = true;
    },
    cancelMarkAsPaid: function cancelMarkAsPaid() {
      this.markingAsPaid.isConfiguring = false;
    },
    markAsPaid: function markAsPaid() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2$markingAsPaid$;
        var _this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.markingAsPaid.isPending = true;
              (_this2$markingAsPaid$ = _this2.markingAsPaid.cancellationToken) === null || _this2$markingAsPaid$ === void 0 || _this2$markingAsPaid$.cancel();
              _this2.markingAsPaid.cancellationToken = axios.CancelToken.source();
              _this = _this2;
              _context.next = 6;
              return request("/v1/orders/".concat(_this2.order.id_order, "/consultant-commissions/payment"), "post", _this.markingAsPaid.form, true, "api", null, _this.markingAsPaid.cancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to mark the commission as not paid", true);
                handleErrorData(_this, errorData);
                _this.markingAsPaid.isPending = false;
                throw e;
              });
            case 6:
              _this2.markingAsPaid.isPending = false;
              _this2.$emit("paid", _this2.markingAsPaid.form);
              _this2.markingAsPaid.isConfiguring = false;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    confirmMarkingAsNotPaid: function confirmMarkingAsNotPaid() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.$refs.confirm.open("Return as not paid", "Are you sure you want to revert this commission payment status as not paid ?", {
                color: "red"
              });
            case 2:
              ok = _context2.sent;
              if (ok) _this3.markAsNotPaid();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    markAsNotPaid: function markAsNotPaid() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$markingAsNotPa;
        var _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.markingAsNotPaid.isPending = true;
              (_this4$markingAsNotPa = _this4.markingAsNotPaid.cancellationToken) === null || _this4$markingAsNotPa === void 0 || _this4$markingAsNotPa.cancel();
              _this4.markingAsNotPaid.cancellationToken = axios.CancelToken.source();
              _this = _this4;
              _context3.next = 6;
              return request("/v1/orders/".concat(_this4.order.id_order, "/consultant-commissions/payment"), "delete", null, true, "api", null, _this.markingAsNotPaid.cancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to mark the commission as not paid", true);
                handleErrorData(_this, errorData);
                _this.markingAsNotPaid.isPending = false;
                throw e;
              });
            case 6:
              _this4.markingAsNotPaid.isPending = false;
              _this4.$emit("notPaid");
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};